<template>
  <d-container
    paddingless-mobile
    fluid
  >
    <div class="max-w-3xl">
      <d-card>
        <v-form
          ref="form"
          :data="form"
          :url="endpoint.url"
          :method="endpoint.method"
          @success="success"
        >
          <template #default="{ errors }">
            <d-card-row>
              <v-input
                v-model="form.name"
                name="name"
              />
            </d-card-row>
            <v-form-address
              v-model="form.billing_address"
              :title="$t('business_entity_address_label')"
              :prefix="'billing_address.'"
              :errors="errors"
            />

            <d-card-row>
              <button
                class="button is-primary"
                type="submit"
              >
                {{ $t("save") }}
              </button>
            </d-card-row>
          </template>
        </v-form>
      </d-card>
    </div>
  </d-container>
</template>

<script>
import { fillFields } from "@/services/helpers";
import address from "@/shared/components/address/form.vue";

export default {
  components: {
    "v-form-address": address,
  },
  props: {
    owner_id: {
      required: true,
      type: Number,
    },
    action: {
      type: String,
      required: true,
    },
    model: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      form: {
        name: "",
        billing_address: {
          city: "",
          country: "ca",
          address_1: "",
          address_2: "",
          province: "qc",
          postal_code: "",
        },
      },
    };
  },
  computed: {
    endpoint() {
      if (this.action === "create") {
        return {
          method: "post",
          url: this.$laravel.route("api.owner-businesses.store", this.owner_id),
        };
      }
      if (this.action === "edit") {
        return {
          method: "patch",
          url: this.$laravel.route("api.owner-businesses.update", {
            owner_business: this.model.id,
            owner: this.model.owner_id,
          }),
        };
      }
      return null;
    },
  },
  created() {
    if (this.action === "edit") {
      this.form = fillFields(this.form, this.model);
    }
  },
  methods: {
    success(event) {
      let query = {};
      if (this.action === "create") {
        query = { saved: true, owner_business_id: event.data.ownerBusiness.id };
      }
      this.$router.push({
        name: "owners.show.owner.businesses",
        query: query,
      });
    },
  },
};
</script>
